import { Divider } from '@mui/material';
import { AddonPriceComposition } from '@niarab2c/frontend-commons/src/types/addon';
import { NiaraIcon } from '@niaratech/niara-icons';
import { formatDate, printPrice } from '@niaratech/niara-js-commons';
import { Tooltip, useIsMobile } from '@niaratech/niara-react-components';
import { Addon, addon as AddonCrudMetadata } from 'niara-spear-crudmodel';
import React from 'react';
import { getGuestsCountLabel } from '../utils';
import * as S from './styles';
export type GroupedPriceByVariant = Addon['priceByVariant'][number] & {
  quantity: number;
  showAges?: boolean;
};
export type AddonGroupedCartItem = {
  addon: Addon;
  scheduleDate?: string;
  scheduleTime?: string;
  variants: GroupedPriceByVariant[];
  totalPrice: AddonPriceComposition;
  onRemoveGroupedItems: () => void;
};
interface AddonCartItemProps {
  isCartView?: boolean;
  groupedCartItem: AddonGroupedCartItem;
}
const AddonCartItem: React.FC<AddonCartItemProps> = ({
  groupedCartItem,
  isCartView
}) => {
  const addon = groupedCartItem?.addon;
  const unitLabel = AddonCrudMetadata.findFieldByName('unit')?.options?.find(option => option?.value === addon?.unit)?.label;
  const isMobile = useIsMobile();
  return <S.Container isCartView={isCartView}>
      <S.HeaderContainer isCartView={isCartView}>
        {isCartView ? <S.AddonThumbnail src={addon?.images?.[0]?.url} alt={addon?.images?.[0]?.name} /> : <S.ThumbWithGallery dataGallery={addon?.images?.map(image => image?.url)} roundImg={isMobile ? '0px' : '4px'} />}
        <S.TitleContainer>
          <S.AddonTitle className={!isCartView ? 'mb-5' : ''}>{addon?.name}</S.AddonTitle>
          <S.AddonSubTitle>{addon?.description}</S.AddonSubTitle>
        </S.TitleContainer>
      </S.HeaderContainer>

      {isCartView && <Divider />}

      <S.BodyContainer isCartView={isCartView}>
        <S.BodyAddonItem isCartView={isCartView}>
          <S.InfoContainer spaceItems>
            <S.AddonInfo weight={500}>{unitLabel}</S.AddonInfo>
            <Tooltip title={"Remover"} placement="top">
              <S.IconButton onClick={groupedCartItem?.onRemoveGroupedItems}>
                <NiaraIcon icon="sysDelete" />
              </S.IconButton>
            </Tooltip>
          </S.InfoContainer>

          {(groupedCartItem?.scheduleDate || groupedCartItem?.scheduleTime) && <S.InfoContainer>
              {groupedCartItem?.scheduleDate && <>
                  <S.AddonInfo>{formatDate(groupedCartItem?.scheduleDate, undefined, 'dd MMM yy')}</S.AddonInfo>
                  <S.AddonSubInfo light>(dia)</S.AddonSubInfo>
                </>}
              {groupedCartItem?.scheduleTime && <>
                  <Divider sx={{
              borderColor: '#e6e6e6',
              height: '10px'
            }} orientation="vertical" />
                  <S.AddonInfo>{groupedCartItem?.scheduleTime}</S.AddonInfo>
                  <S.AddonSubInfo light>(horas)</S.AddonSubInfo>
                </>}
            </S.InfoContainer>}

          <S.InfoContainer>
            <S.AddonSubInfo>{getGuestsCountLabel(groupedCartItem?.variants)}</S.AddonSubInfo>
          </S.InfoContainer>
        </S.BodyAddonItem>
      </S.BodyContainer>
      {isCartView && <S.AddonPrice>
          {printPrice(groupedCartItem?.totalPrice.total.value, groupedCartItem?.totalPrice?.total?.currency)}
        </S.AddonPrice>}
    </S.Container>;
};
export default AddonCartItem;